<template>
    <form @submit.prevent="onSubmit" id="contactUsForm">
        <div id="scroll">
            <div v-if="isSuccessMessage">
                <div class="alert alert-success" role="alert">
                    {{ $t("contactUs.SuccessMessage") }}
                </div>
            </div>
            <div v-if="isFailed">
                <div class="alert alert-danger" role="alert">
                    {{ $t("contactUs.FailureMessage") }}
                </div>
            </div>
        </div>
        <div id="contactus">
            <div class="form-row">
                <div class="col-md-6 form-group">
                    <label>{{ $t("contactUs.userName") }}</label>
                    <span class="text-danger">*</span>
                    <input v-model="ContactUsSubmitionFormViewModel.userName" type="text" class="bg-transparent form-control " :class="{
          'is-invalid':
            $v.ContactUsSubmitionFormViewModel.userName.$dirty &&
            !$v.ContactUsSubmitionFormViewModel.userName.required&&!isSuccessed,
        }" />
                    <div class="text-danger" v-if="!isSuccessed">
                        <span v-if="
            $v.ContactUsSubmitionFormViewModel.userName.$dirty &&
              !$v.ContactUsSubmitionFormViewModel.userName.required
          ">{{$t("contactUs.ThisFiledIsRequired")}}</span>
                        <span v-if="
            ($v.ContactUsSubmitionFormViewModel.userName.$dirty||$v.ContactUsSubmitionFormViewModel.userName.$touch) &&
              !$v.ContactUsSubmitionFormViewModel.userName.maxLength
          ">{{$t("contactUs.MaxLengthError")}}</span>
                        <span v-if="($v.ContactUsSubmitionFormViewModel.userName.$dirty||$v.ContactUsSubmitionFormViewModel.userName.$touch) &&
              !isLetter($v.ContactUsSubmitionFormViewModel.userName.$model)
          &&$v.ContactUsSubmitionFormViewModel.userName.required">{{$t("contactUs.CharacterOnly")}}</span>
                    </div>
                </div>
                <div class="col-md-6 form-group">
                    <label>{{ $t("contactUs.email") }}</label>
                    <span class="text-danger">*</span>
                    <input v-model="ContactUsSubmitionFormViewModel.email" type="text" class="bg-transparent form-control" :class="{
                        'is-invalid':
                            $v.ContactUsSubmitionFormViewModel.email.$dirty &&
                            !$v.ContactUsSubmitionFormViewModel.email.required&&!isSuccessed,
                        }" />

                    <div class="text-danger" v-if="!isSuccessed">
                        <span v-if="
                            $v.ContactUsSubmitionFormViewModel.email.$dirty &&
                            !$v.ContactUsSubmitionFormViewModel.email.required
                        ">{{$t("contactUs.ThisFiledIsRequired")}}</span>
                        <span v-if="
                        ($v.ContactUsSubmitionFormViewModel.email.$dirty||$v.ContactUsSubmitionFormViewModel.email.$touch) &&
                            !$v.ContactUsSubmitionFormViewModel.email.email
                        ">
                            {{$t("contactUs.EmailErrorFormat")}}
                        </span>
                        <span v-if="
                            ($v.ContactUsSubmitionFormViewModel.email.$dirty||$v.ContactUsSubmitionFormViewModel.email.$touch) &&
                            !$v.ContactUsSubmitionFormViewModel.email.maxLength
                        ">
                            {{$t("contactUs.MaxLengthError")}}
                        </span>
                    </div>
                </div>
                <div class="col-md-6 form-group">
                    <label>{{ $t("contactUs.title") }}</label>
                    <span class="text-danger">*</span>
                    <input v-model="ContactUsSubmitionFormViewModel.title" type="text" class="bg-transparent form-control" :class="{
          'is-invalid':
            $v.ContactUsSubmitionFormViewModel.title.$dirty &&
            !$v.ContactUsSubmitionFormViewModel.title.required&&!isSuccessed,
        }" />
                    <div class="text-danger" v-if="!isSuccessed">
                        <span v-if="
            $v.ContactUsSubmitionFormViewModel.title.$dirty &&
              !$v.ContactUsSubmitionFormViewModel.title.required
          ">{{$t("contactUs.ThisFiledIsRequired")}}</span>
                        <span v-if="
            ($v.ContactUsSubmitionFormViewModel.title.$dirty||$v.ContactUsSubmitionFormViewModel.title.$touch) &&
              !$v.ContactUsSubmitionFormViewModel.title.maxLength
          ">{{$t("contactUs.MaxLengthError")}}</span>
                        <span v-if="($v.ContactUsSubmitionFormViewModel.title.$dirty||$v.ContactUsSubmitionFormViewModel.title.$touch) &&
              !isLetter($v.ContactUsSubmitionFormViewModel.title.$model)
          &&$v.ContactUsSubmitionFormViewModel.title.required">{{$t("contactUs.CharacterOnly")}}</span>
                    </div>
                </div>
                <div class="col-md-6 form-group">
                    <label>{{ $t("contactUs.contactNumber") }}</label>
                    <span class="text-danger">*</span>
                    <input v-model="ContactUsSubmitionFormViewModel.contactNumber" type="text" class="bg-transparent form-control " :class="{
                            'is-invalid':
                                $v.ContactUsSubmitionFormViewModel.contactNumber.$dirty &&
                                !$v.ContactUsSubmitionFormViewModel.contactNumber.required&&!isSuccessed,
                            }" />
                    <div class="text-danger" v-if="!isSuccessed">
                        <span v-if="
                            $v.ContactUsSubmitionFormViewModel.contactNumber.$dirty &&
                            !$v.ContactUsSubmitionFormViewModel.contactNumber.required
                        ">{{$t("contactUs.ThisFiledIsRequired")}}</span>
                        <span v-if="
                            ($v.ContactUsSubmitionFormViewModel.contactNumber.$dirty||$v.ContactUsSubmitionFormViewModel.contactNumber.$touch) &&
                            !$v.ContactUsSubmitionFormViewModel.contactNumber.minLength
                            
                        ">{{$t("contactUs.MinLengthErrorContactNumber")}}</span>
                        <span v-if="
                            ($v.ContactUsSubmitionFormViewModel.contactNumber.$dirty||$v.ContactUsSubmitionFormViewModel.contactNumber.$touch)
                            && 
                            !$v.ContactUsSubmitionFormViewModel.contactNumber.maxLength
                        ">{{$t("contactUs.MaxLengthErrorContactNumber")}}</span>

                        <span v-if="
                            ($v.ContactUsSubmitionFormViewModel.contactNumber.$dirty||$v.ContactUsSubmitionFormViewModel.contactNumber.$touch) && 
                            $v.ContactUsSubmitionFormViewModel.contactNumber.required &&
                            !isNumber($v.ContactUsSubmitionFormViewModel.contactNumber.$model)
                        ">{{$t("contactUs.ContactNumberFormatError")}}</span>
                    </div>
                </div>
                <div class="col-md-6 form-group">
                    <label>{{ $t("contactUs.Category") }}</label>
                    <span class="text-danger">*</span>
                    <select v-model="selected" id="categorieslist" class="bg-transparent form-control " :class="{
          'is-invalid':
            $v.selected.$dirty&&
            !$v.selected.required&&!isSuccessed,
        }">
                        <option v-if="language=='en'" v-for="category in categories" v-bind:key="category.categoryId" :value="category.CategoryId">

                            {{ category.NameEn }}
                        </option>
                        <option v-if="language=='ar'" v-for="category in categories" v-bind:key="category.categoryId" :value="category.CategoryId">

                            {{ category.NameAr }}
                        </option>
                    </select>
                    <div class="text-danger" v-if="!isSuccessed">
                        <span v-if="
            $v.selected.$dirty&&
              !$v.selected.required
          ">{{$t("contactUs.ThisFiledIsRequired")}}</span>
                    </div>
                </div>
                <div class="col-md-6 form-group">
                    <label>{{ $t("contactUs.notes") }}</label>
                    <span class="text-danger">*</span>
                    <textarea v-model="ContactUsSubmitionFormViewModel.notes" class="bg-transparent form-control" :class="{
                  'is-invalid':
                    $v.ContactUsSubmitionFormViewModel.notes.$dirty &&
                    !$v.ContactUsSubmitionFormViewModel.notes.required&&!isSuccessed,
                }"></textarea>
                    <div class="text-danger" v-if="!isSuccessed">
                        <span v-if="
            $v.ContactUsSubmitionFormViewModel.notes.$dirty &&
              !$v.ContactUsSubmitionFormViewModel.notes.required
          ">{{$t("contactUs.ThisFiledIsRequired")}}</span>

                        <span v-if="
            ($v.ContactUsSubmitionFormViewModel.notes.$dirty||$v.ContactUsSubmitionFormViewModel.notes.$touch) &&
              !$v.ContactUsSubmitionFormViewModel.notes.maxLength
          ">{{$t("contactUs.MaxLengthErrorNotes")}}</span>
                        <span v-if="($v.ContactUsSubmitionFormViewModel.notes.$dirty||$v.ContactUsSubmitionFormViewModel.notes.$touch)&&
              !isLetter($v.ContactUsSubmitionFormViewModel.notes.$model)
          &&$v.ContactUsSubmitionFormViewModel.notes.required">{{$t("contactUs.CharacterOnly")}}</span>
                    </div>
                </div>
                <div class='col-md-12 form-group'>
                <vue-recaptcha ref="recaptcha" @verify="markRecaptchaAsVerified" sitekey="6LfXs88aAAAAADmKdycMOqfmk-wlg82GVFh3V619"  :loadRecaptchaScript="true">
                </vue-recaptcha>
                <div class="text-danger" id="recaptchamessage">
                <span> {{$t('contactUs.ThisFiledIsRequired')}}</span>
            </div>
            <div class="contactus-submit text-center">
                <button class="bg-primary btn btn-primary text-white">{{ $t("Submit") }}</button>
            </div>
            </div>
            </div>
        </div>

    </form>

</template>


<script>
    import {
        required,
        email,
        minLength,
        maxLength
    } from "vuelidate/lib/validators";
    import VueRecaptcha from 'vue-recaptcha';

    export default {
        name: "contactus",
        components: {
            VueRecaptcha
        },

        data: function() {

            return {
                selected: "",
                categories: [{
                    id: "1",
                    name: "A"
                }],
                file: "",
                title: "",
                isValidExtention: true,
                isFileSizeValid: true,

                ContactUsSubmitionFormViewModel: {
                    title: "",
                    userName: "",
                    contactNumber: "",
                    email: "",
                    notes: "",
                    categoryId: "",
                },
                isSubmitted: false,
                isSuccessed: false,

                showConfirmation: false,
                language: "",
                isSuccessMessage: false,
                isFailed: false,
                isInvalid: false,
                recaptchaVerified: false,
                RecaptchaResponse: ""


            };
        },
        validations: {
            ContactUsSubmitionFormViewModel: {
                title: {
                    required,
                    maxLength: maxLength(50)
                },
                userName: {
                    required,
                    maxLength: maxLength(50),
                },
                contactNumber: {
                    required,
                    minLength: minLength(8),
                    maxLength: maxLength(11)


                },
                notes: {
                    required,
                    maxLength: maxLength(100)
                },
                email: {
                    required,
                    email,
                    maxLength: maxLength(50)

                },

            },
            selected: {
                required
            },
        },
        mounted: function() {

            var url_string = window.location.href;
            this.language = url_string.split('/').filter(u => u.length == 2).includes('ar') ? 'ar' : 'en';
            this.isSubmitted = true;
            this.getCategories();
            document.getElementById("recaptchamessage").style.display = "none";
        },

        methods: {
            markRecaptchaAsVerified(response) {
                this.pleaseTickRecaptchaMessage = '';
                this.recaptchaVerified = true;
                document.getElementById("recaptchamessage").style.display = "none";
                this.RecaptchaResponse = response;
            },
            isLetter: function(value) {
                if (!value.match(/[|\\/~^:<>,;?!&%$@*+]/)) {
                    return true;
                } else {
                    this.isInvalid = true;
                    return false;
                }
            },
            isNumber: function(value) {
                if (/^[\d*]+$/.test(value)) {
                    return true;
                } else {
                    this.isInvalid = true;
                    return false;
                }
            },
            getCategories: function() {
                var apiUrl = window.location.origin;
                var url = apiUrl + "/api/contactus/getCategories";
                this.$http
                    .get(url, {
                        headers: {
                            "Accept-Language": "en"
                        },
                    })
                    .then(function(response) {
                        this.categories = response.data.Data;
                    })
                    .catch(function() {});
            },
            onSubmit: function() {

                this.$v.$touch();
                if (!this.recaptchaVerified) {
                    document.getElementById("recaptchamessage").style.display = "block";
                    return; // prevent form from submitting
                }
                if (!this.isLetter(this.ContactUsSubmitionFormViewModel.title) ||
                    !this.isLetter(this.ContactUsSubmitionFormViewModel.userName) ||
                    !this.isLetter(this.ContactUsSubmitionFormViewModel.notes)) {
                    this.isSuccessed = false;
                    return;
                }
                // stop here if form is invalid
                if (this.$v.$invalid) return;
                var _this = this;
                this.isSubmitted = true;

                var formdata = new FormData();

                formdata.append("Title", _this.ContactUsSubmitionFormViewModel.title);
                formdata.append("RecaptchaResponse", _this.RecaptchaResponse);
                formdata.append(
                    "UserName",
                    _this.ContactUsSubmitionFormViewModel.userName
                );
                formdata.append("Notes", _this.ContactUsSubmitionFormViewModel.notes);
                formdata.append("Email", _this.ContactUsSubmitionFormViewModel.email);
                formdata.append(
                    "ContactNumber",
                    _this.ContactUsSubmitionFormViewModel.contactNumber
                );

                formdata.append("CategoryId", _this.selected);
                this.$http
                    .post("/api/contactus/submitContactUs", formdata, {
                        headers: {
                            "Accept-Language": "en",
                        },
                    })
                    .then(function(response) {
                        _this.isSubmitted = true;
                        _this.ContactUsSubmitionFormViewModel = response.data;
                        _this.isSuccessed = true;
                        _this.showConfirmation = true;
                        _this.isSuccessMessage = true;
                        setTimeout(() => {
                            //  location.href = "#";
                            //  location.href = "#scroll";
                            var element = document.getElementById('scroll');
                            element.scrollIntoView({
                                behavior: 'smooth'
                            });


                        }, 100);
                        setTimeout(() => {
                            this.isSuccessMessage = false;

                        }, 3000);
                        //Confirm msg
                        this.selected="";
        this.$refs.recaptcha.reset();

                    })
                    .catch(function() {
                        _this.isFailed = true;
                        _this.isSubmitted = false;
                        _this.isSuccessed = false;
                        _this.showConfirmation = true;
                        setTimeout(() => {
                            var element2 = document.getElementById('scroll');
                            element2.scrollIntoView({
                                behavior: 'smooth'
                            });
                        }, 100);
                        //msg
                    });
            },
        },
    };

</script>
